/**
 * Created by ys on 2017/10/31.
 */
import {encrypt} from './zEncrypt.js';
import {encryptUtil} from './zEncryptUtil.js';
const RANDON_RANGE = [3,3];
export  function encryptSpec() {
  var CHARSET = 'utf-8';
  var rawPswd = 'vcarecityOfZhuhai';
  var LOGIN_KEY = new encrypt().markMD5(rawPswd);
  var KEY1;
  var KEY2;
  var KEY3;
  var EncryptKeys ={};
  EncryptKeys = getApiEncryptKeys();
  function getApiEncryptKeys(){
    var rawPswd = new encrypt().markMD5('EncryptKeys');
    KEY1 = rawPswd.substring(1, 1 + 16);
    KEY2 = rawPswd.substring(3, 3 + 16);
    KEY3 = rawPswd.substring(7, 7 + 16);
    setApiEncryptKeys(KEY1, KEY2, KEY3);
    var key1='key1';
    var key2='key2';
    var key3='key3';
    EncryptKeys[key1]=KEY1;
    EncryptKeys[key2]=KEY2;
    EncryptKeys[key3]=KEY3;
    return EncryptKeys;
  };
  function setApiEncryptKeys(k1, k2, k3){
    KEY1 = k1;
    KEY2 = k2;
    KEY3 = k3;
  };
  //这个方法的目的是在传输过程中保护账号和密码信息
  this.encryptLoginInfo=function (clearText) {
    var strs = "";
    try
    {
      var bt = new encryptUtil().jsencrypt(clearText, LOGIN_KEY);
      strs = bt;
    }
    catch (e)
    {
      alert(e.name + ": " + e.message);
    }
    return strs;
  };
  //用于解密登录返回的整个Json
  this.decryptLoginResult=function( user, cipherText) {
    var sb = user.split("").reverse();
    var key = new encrypt().markMD5(LOGIN_KEY + sb.join(""));
    var strs = "";
    try
    {
      var bt = new encryptUtil().jsdecrypt(cipherText, key);
      strs = bt;
    }
    catch (e)
    {
      alert(e.name + ": " + e.message);
    }
    return strs;
  };
  function setApiEncryptKeys(k1, k2, k3){
    KEY1 = k1;
    KEY2 = k2;
    KEY3 = k3;
  };
  this.setApiEncryptKeysForE = function(k1, k2, k3){
    setApiEncryptKeys(k1, k2, k3);
  };
  this.getResponseKeyForI = function() {
    var encryptInfonum = 0;
    var encryptInfonumcheck = null
    for(;encryptInfonumcheck == null;){
      encryptInfonum = getResponseKeyForI();
      encryptInfonumcheck = getResponseKey(encryptInfonum);
    }
    return encryptInfonum;
  };
  function getResponseKey( encryptInfo) {
    var type = (encryptInfo & 0xf0) >> 4;
    switch (type)
    {
      case 0:
        return null;
      case 1:
        return KEY2;
      case 2:
        return KEY3;
      case 3:
        return KEY1;
      default:
        return KEY1;
    }
  };
  function getResponseKeyForI () {
    let encryptInfornum = 0;
    let requestKey = Math.floor(Math.random() * 1000) % RANDON_RANGE[0] + 1;
    let responseKey = Math.floor(Math.random() * 1000) % RANDON_RANGE[1] + 1;
    encryptInfornum |= requestKey & 0xf;
    encryptInfornum |= (responseKey << 4) & 0xf0;
    return encryptInfornum;
  };
  //用于加密非登录接口请求参数
  this.encryptParams = function ( clearText, encryptInfo) {
    var strs = "";
    var key = getRequestKey(encryptInfo);///============================
    if (key !== null)
    {
      try
      {
        var bt = new encryptUtil().jsencrypt(clearText, key);
        strs = bt;
      }
      catch (e)
      {
        alert(e.name + ": " + e.message);
      }
      return strs;
    }
    else
    {
      return clearText;
    }
  };
  function getRequestKey( encryptInfo) {
    var type = encryptInfo & 0xf;
    switch (type)
    {
      case 0:
        return null;
      case 1:
        return KEY3;
      case 2:
        return KEY1;
      case 3:
        return KEY2;
      default:
        return KEY1;
    }
  };

  //用于解密非登录接口返回参数
  this.decryptResult=function ( cipherText, encryptInfo) {
    var strs = "";
    var key = getResponseKey(encryptInfo);
    if (key !== null)
    {
      try
      {
        var bt = new encryptUtil().jsdecrypt(cipherText, key);///////=========================================
        strs = bt;
      }
      catch (e)
      {
        alert(e.name + ": " + e.message);
      }
      return strs;
    }
    else
    {
      return cipherText;
    }
  }
}




// WEBPACK FOOTER //
// ./src/utils/zEncryptSpec.js